<!--
  (c) Copyright 2024 Calabrio, Inc.
  All Rights Reserved. www.calabrio.com LICENSED MATERIALS
  Property of Calabrio, Inc., Minnesota, USA

  No part of this publication may be reproduced, stored or transmitted,
  in any form or by any means (electronic, mechanical, photocopying,
  recording or otherwise) without prior written permission from Calabrio, Inc.
-->

<template>
  <div class="wy-va-optimization-comparison">
    <div class="comparison-small-title">{{$t(currentPageInfo.subtitle)}}</div>
    <div class="performace-comparison-title">Performance Comparison

    <el-button v-if="!(this.conversationsTableColumns[0] && conversationsResults.length == 0 && this.containedTableColumns[0] && containedResults.length == 0 && this.handedOffTableColumns[0] && handOffResults.length == 0 && this.corpusTableColumns[0] && selectedCompareBy != 'channel' && corpusResults.length == 0 && this.responseTableColumns[0] && responseResults.length == 0 && this.feedbackTableColumns[0] && feedbackResults.length == 0 && this.issuesTableColumns[0] && issuesResults.length == 0 && this.selectedCompareBy!='channel' && this.nluTrainingTableColumns[0] && nluTrainingResults.length == 0)" class="export-btn" round @click="handleExport">
      <div class="export-icon"></div>
      <span class="export-text">Export</span> 
    </el-button>
    </div>
    <div class="wy-optimization-table-section">
      <div class="wy-optimization-table-section-header">
        <div>
          <span class="compare-by-label">Compare by</span>
          <el-radio v-model="selectedCompareBy" label="date" @change="changeCompareBy">Date</el-radio>
          <el-select
            :disabled="!showDateFilter"
            v-model="selectedViewDateRange"
            collapse-tags
            size="mini"
            style="margin-left: 5px;"
            class="date-range-dropdown"
            popper-class="table-filter-dropdown date-range"
            :popper-append-to-body="false"
            @change="changeDateRange"
            placeholder="Select range">
            <el-option
              v-for="(item) in dateRangeTypes"
              :disabled="item.disabled"
              :key="item.type"
              :label="item.label"
              :value="item.type">
            </el-option>
          </el-select>
          <el-radio v-model="selectedCompareBy" label="lang" class="radio-language" @change="changeCompareBy">Language</el-radio>
          <el-radio v-model="selectedCompareBy" label="channel" @change="changeCompareBy">Channel</el-radio>
        </div>
      </div>
      <wy-table-list v-if="pagePanels.conversationsTable" ref="conversationsTable" :controller="module" :noData="conversationInfo.noData" :panelLoading="conversationInfo.loading" :tableName="`conversations`" :tableDataResults="conversationsResults" :tableColumns="conversationsTableColumns" :defaultHeaders="setDefaultHeader(conversationsTableColumns)" :enableSelection="true" :hasSubtitle = hasSubtitle(conversationsColumns) :defaultSort="{name: 'total', type: 1}" :mode="'generic'" :noDataMsg="'Data not available.'" :defaultPanelHeight="getTableBodyHeight('conversations')" />
      
      <wy-table-list v-if="pagePanels.containedTable && containedTableColumns[0]" ref="containedTable" :controller="module" :noData="containedInfo.noData" :panelLoading="containedInfo.loading" :tableName="`contained`" :tableDataResults="containedResults" :tableColumns="containedTableColumns" :defaultHeaders="setDefaultHeader(containedTableColumns)" :enableSelection="true" :hasSubtitle = hasSubtitle(containedColumns) :defaultSort="{name: 'total', type: 1}" :mode="'generic'" :noDataMsg="'Data not available.'" :defaultPanelHeight="getTableBodyHeight('contained')" />
      
      <wy-table-list v-if="pagePanels.handedOffTable  && handedOffTableColumns[0]" ref="handedOffTable" :controller="module" :noData="handOffInfo.noData" :panelLoading="handOffInfo.loading" :tableDataResults="handOffResults" :tableColumns="handedOffTableColumns" :defaultHeaders="setDefaultHeader(handedOffTableColumns)" :enableSelection="true" :hasSubtitle = hasSubtitle(handedOffColumns) :defaultSort="{name: 'total', type: 1}" :mode="'generic'" :defaultPanelHeight="getTableBodyHeight('handedOff')" />

      <wy-table-list v-if="pagePanels.corpusTable && corpusTableColumns[0] && selectedCompareBy!='channel'" ref="corpusTable" :controller="module" :noData="corpusInfo.noData" :panelLoading="corpusInfo.loading" :tableDataResults="corpusResults" :tableColumns="corpusTableColumns" :defaultHeaders="setDefaultHeader(corpusTableColumns)" :enableSelection="true" :hasSubtitle = hasSubtitle(corpusColumns) :defaultSort="{name: 'total', type: 1}" :mode="'generic'" :defaultPanelHeight="getTableBodyHeight('corpus')" />

      <wy-table-list v-if="pagePanels.responseTable && responseTableColumns[0]" ref="responseTable" :controller="module" :noData="responseInfo.noData" :panelLoading="responseInfo.loading" :tableDataResults="responseResults" :tableColumns="responseTableColumns" :defaultHeaders="setDefaultHeader(responseTableColumns)"  :enableSelection="true" :hasSubtitle = hasSubtitle(responseColumns) :defaultSort="{name: 'total', type: 1}" :mode="'generic'" :defaultPanelHeight="getTableBodyHeight('response')" />

      <wy-table-list v-if="pagePanels.feedbackTable && feedbackTableColumns[0] && handleTableConditions()" ref="feedbackTable" :controller="module"  :noData="feedbackInfo.noData" :panelLoading="feedbackInfo.loading" :tableDataResults="feedbackResults" :tableColumns="feedbackTableColumns" :defaultHeaders="setDefaultHeader(feedbackTableColumns)" :enableSelection="true" :hasSubtitle = hasSubtitle(feedbackColumns) :defaultSort="{name: 'total', type: 1}" :mode="'generic'" :defaultPanelHeight="getTableBodyHeight('feedback')" />
      
      <wy-table-list v-if="pagePanels.issuesTable && issuesTableColumns[0]" ref="issuesTable" :controller="module" :noData="issuesInfo.noData" :panelLoading="issuesInfo.loading" :tableDataResults="issuesResults" :tableColumns="issuesTableColumns" :enableSelection="true" :hasSubtitle = hasSubtitle(issuesColumns) :defaultSort="{name: 'total', type: 1}" :mode="'generic'" :defaultPanelHeight="getTableBodyHeight('issues')" />

      <wy-table-list v-if="pagePanels.nluTrainingTable && selectedCompareBy!='channel'" ref="nluTrainingTable" :controller="module" :noData="nluTrainingInfo.noData" :panelLoading="nluTrainingInfo.loading" :tableDataResults="nluTrainingResults" :tableColumns="nluTrainingTableColumns" :defaultHeaders="setDefaultHeader(nluTrainingTableColumns)" :enableSelection="true" :hasSubtitle = hasSubtitle(nluTrainingColumns) :defaultSort="{name: 'total', type: 1}" :mode="'generic'" :defaultPanelHeight="getTableBodyHeight('nluTraining')" />
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import moment from 'moment';
import { mapGetters, mapActions } from 'vuex';
import WyUtils from '../../library/wy-utils.js';
import WyTableList from '../widgets/wy-table-list-v2';
// import ObjectsToCsv from 'objects-to-csv';
import WyVaOptimizationUtils from '../optimization/utils/wy-va-optimization-utils.js';
import WyChartModule from '../../library/wy-chart-module.js';

export default Vue.extend({
  name: 'wy-va-optimization-comparison',
  components: {
    'wy-table-list': WyTableList,
  },

  data() {
    return {
      module: this,
      loading: false,
      loadTables: false,
      showTable: false,
      wyChart: null,
      initDate: null,
      pagePanels: null,

      selectedCompareBy: 'date',
      selectedViewDateRange: 'month',

      customDateRangeTypes: {
        'year': {
          type: 'year',
          key: 'yearly',
          label: 'Yearly',
          tickformat: '%Y',
          disabled: false,
          duraion: 99999
        },
        'quarter': {
          type: 'quarter',
          key: 'quarterly',
          label: 'Quarterly',
          tickformat: '%b %d %Y',
          disabled: false,
          duraion: 365
        },
        'month': {
          type: 'month',
          key: 'monthly',
          label: 'Monthly',
          tickformat: '%b %Y',
          disabled: false,
          duraion: 90
        },
        'day': {
          type: 'day',
          key: 'daily',
          label: 'Daily',
          tickformat: '%b %d %Y',
          disabled: false,
          duraion: 30
        }
      },
      containedConversationWithBotIndentList:[                    
        'Received positive feedback', 
        'Received negative feedback'
      ],
      conversationsHandedOffIndentList:[
        'Customer requested handoff', 
        'Automatic handoff after intent-based trigger'
      ],
      customerMsgsUnderstoodIndentList:[
        'False-positive rate',
        'Customer messages with DYM',
      ],
      customerMsgsNotUnderstoodIndentList:[
        'Candidates for new intents', 
        'Candidates for existing intents',
        'Out of domain'
      ],

      defaultHeader: [
        {
          lable: 'Name'
        },
        {
          label: 'Target'
        }
      ],

      conversationsColumns: [
        {label: "Conversations", name: "conversations", mandatory: true, selected: false, sortable: true, hasSubtitle: false, group: 'Total VA volumes', cssClass: 'conversations', align:"left", minWidth: 300, fixed: true, copyable: false, isEditTopicName: false},
        {label: "Target", name: "target", mandatory: true, selected: false, sortable: true, hasSubtitle: false, group: 'Target', cssClass: 'target', align:"right", minWidth: 50, fixed: true, copyable: false, isEditTopicName: false},
        // {label: "Total", name: "total", mandatory: true, selected: false, sortable: true, hasSubtitle: false, group: 'Total', cssClass: 'total', align:"right", minWidth: 80, fixed: false, copyable: false, isEditTopicName: false, hasIcon: true},
        // {label: "Trend", name: "trendGraph", mandatory: true, selected: false, sortable: true, hasSubtitle: false, group: 'Trend', cssClass: 'trend', align:"centre", minWidth: 150, fixed: false, copyable: false, isEditTopicName: false},
        {label: "DynamicFields", name: "dynamicFields", mandatory: false, selected: false, sortable: true, hasSubtitle: false, group: 'DynamicFields', cssClass: 'dynamicFields', minWidth: 225, fixed: false, copyable: false, isEditTopicName: false, hasIcon: true},
      ],
      containedColumns: [
        {label: "Contained", name: "contained", mandatory: true, selected: false, sortable: true, hasSubtitle: false, group: 'Contained conversations', cssClass: 'contained', align:"left", minWidth: 300, fixed: true, copyable: false, isEditTopicName: false},
        {label: "Target", name: "target", mandatory: true, selected: false, sortable: true, hasSubtitle: false, group: 'Target', cssClass: 'target', align:"right", minWidth: 50, fixed: true, copyable: false, isEditTopicName: false},
        // {label: "Total", name: "total", mandatory: true, selected: false, sortable: true, hasSubtitle: false, group: 'Total', cssClass: 'total', align:"right", minWidth: 80, fixed: false, copyable: false, isEditTopicName: false, hasIcon: true},
        // {label: "Trend", name: "trendGraph", mandatory: true, selected: false, sortable: true, hasSubtitle: false, group: 'Trend', cssClass: 'trend', align:"centre", minWidth: 150, fixed: false, copyable: false, isEditTopicName: false},
        {label: "DynamicFields", name: "dynamicFields", mandatory: false, selected: false, sortable: true, hasSubtitle: false, group: 'DynamicFields', cssClass: 'dynamicFields', minWidth: 225, fixed: false, copyable: false, isEditTopicName: false, hasIcon: true},
      ],
      handedOffColumns: [
        {label: "Handed Off", name: "handedOff", mandatory: true, selected: false, sortable: true, hasSubtitle: false, group: 'Handed Off Conversations', cssClass: 'handedOff', align:"left", minWidth: 300, fixed: true, copyable: false, isEditTopicName: false},
        {label: "Target", name: "target", mandatory: true, selected: false, sortable: true, hasSubtitle: false, group: 'Target', cssClass: 'target', align:"right", minWidth: 50, fixed: true, copyable: false, isEditTopicName: false},
        // {label: "Total", name: "total", mandatory: true, selected: false, sortable: true, hasSubtitle: false, group: 'Total', cssClass: 'total', align:"right", minWidth: 80, fixed: false, copyable: false, isEditTopicName: false, hasIcon: true},
        // {label: "Trend", name: "trendGraph", mandatory: true, selected: false, sortable: true, hasSubtitle: false, group: 'Trend', cssClass: 'trend', align:"centre", minWidth: 150, fixed: false, copyable: false, isEditTopicName: false},
        {label: "DynamicFields", name: "dynamicFields", mandatory: false, selected: false, sortable: true, hasSubtitle: false, group: 'DynamicFields', cssClass: 'dynamicFields', minWidth: 225, fixed: false, copyable: false, isEditTopicName: false, hasIcon: true},
      ],
      // understandingColumns: [
      //   {label: "Understanding", name: "understanding", mandatory: true, selected: false, sortable: true, hasSubtitle: false, group: 'Understanding', cssClass: 'understanding', align:"left", minWidth: 300, fixed: true, copyable: false, isEditTopicName: false},
      //   {label: "Target", name: "target", mandatory: true, selected: false, sortable: true, hasSubtitle: false, group: 'Target', cssClass: 'target', align:"right", minWidth: 50, fixed: true, copyable: false, isEditTopicName: false},
      //   // {label: "Total", name: "total", mandatory: true, selected: false, sortable: true, hasSubtitle: false, group: 'Total', cssClass: 'total', align:"right", minWidth: 80, fixed: false, copyable: false, isEditTopicName: false, hasIcon: true},
      //   // {label: "Trend", name: "trendGraph", mandatory: true, selected: false, sortable: true, hasSubtitle: false, group: 'Trend', cssClass: 'trend', align:"centre", minWidth: 150, fixed: false, copyable: false, isEditTopicName: false},
      //   {label: "DynamicFields", name: "dynamicFields", mandatory: false, selected: false, sortable: true, hasSubtitle: false, group: 'DynamicFields', cssClass: 'dynamicFields', minWidth: 225, fixed: false, copyable: false, isEditTopicName: false, hasIcon: true},
      // ],
      // goalsColumns: [
      //   {label: "Goals", name: "goals", mandatory: true, selected: false, sortable: true, hasSubtitle: false, group: 'Goals', cssClass: 'goals', align:"left", minWidth: 300, fixed: true, copyable: false, isEditTopicName: false},
      //   {label: "Target", name: "target", mandatory: true, selected: false, sortable: true, hasSubtitle: false, group: 'Target', cssClass: 'target', align:"right", minWidth: 50, fixed: true, copyable: false, isEditTopicName: false},
      //   // {label: "Total", name: "total", mandatory: true, selected: false, sortable: true, hasSubtitle: false, group: 'Total', cssClass: 'total', align:"right", minWidth: 80, fixed: false, copyable: false, isEditTopicName: false, hasIcon: true},
      //   // {label: "Trend", name: "trendGraph", mandatory: true, selected: false, sortable: true, hasSubtitle: false, group: 'Trend', cssClass: 'trend', align:"centre", minWidth: 150, fixed: false, copyable: false, isEditTopicName: false},
      //   {label: "DynamicFields", name: "dynamicFields", mandatory: false, selected: false, sortable: true, hasSubtitle: false, group: 'DynamicFields', cssClass: 'dynamicFields', minWidth: 225, fixed: false, copyable: false, isEditTopicName: false, hasIcon: true},
      // ],
      feedbackColumns: [
        {label: "Feedback", name: "feedback", mandatory: true, selected: false, sortable: true, hasSubtitle: false, group: 'Feedback', cssClass: 'feedback', align:"left", minWidth: 300, fixed: true, copyable: false, isEditTopicName: false},
        {label: "Target", name: "target", mandatory: true, selected: false, sortable: true, hasSubtitle: false, group: 'Target', cssClass: 'target', align:"right", minWidth: 50, fixed: true, copyable: false, isEditTopicName: false},
        // {label: "Total", name: "total", mandatory: true, selected: false, sortable: true, hasSubtitle: false, group: 'Total', cssClass: 'total', align:"right", minWidth: 80, fixed: false, copyable: false, isEditTopicName: false, hasIcon: true},
        // {label: "Trend", name: "trendGraph", mandatory: true, selected: false, sortable: true, hasSubtitle: false, group: 'Trend', cssClass: 'trend', align:"centre", minWidth: 150, fixed: false, copyable: false, isEditTopicName: false},
        {label: "DynamicFields", name: "dynamicFields", mandatory: false, selected: false, sortable: true, hasSubtitle: false, group: 'DynamicFields', cssClass: 'dynamicFields', minWidth: 225, fixed: false, copyable: false, isEditTopicName: false, hasIcon: true},
      ],
      issuesColumns: [
        {label: "Issues", name: "issues", mandatory: true, selected: false, sortable: true, hasSubtitle: false, group: 'Issues', cssClass: 'issues', align:"left", minWidth: 300, fixed: true, copyable: false, isEditTopicName: false},
        {label: "Target", name: "target", mandatory: true, selected: false, sortable: true, hasSubtitle: false, group: 'Target', cssClass: 'target', align:"right", minWidth: 50, fixed: true, copyable: false, isEditTopicName: false},
        // {label: "Total", name: "total", mandatory: true, selected: false, sortable: true, hasSubtitle: false, group: 'Total', cssClass: 'total', align:"right", minWidth: 80, fixed: false, copyable: false, isEditTopicName: false, hasIcon: true},
        // {label: "Trend", name: "trendGraph", mandatory: true, selected: false, sortable: true, hasSubtitle: false, group: 'Trend', cssClass: 'trend', align:"centre", minWidth: 150, fixed: false, copyable: false, isEditTopicName: false},
        {label: "DynamicFields", name: "dynamicFields", mandatory: false, selected: false, sortable: true, hasSubtitle: false, group: 'DynamicFields', cssClass: 'dynamicFields', minWidth: 225, fixed: false, copyable: false, isEditTopicName: false, hasIcon: true},
      ],
      // customerBehaviourColumns: [
      //   {label: "Customer Behaviour", name: "customerBehaviour", mandatory: true, selected: false, sortable: true, hasSubtitle: false, group: 'Customer Behaviour', cssClass: 'customerBehaviour', align:"left", minWidth: 300, fixed: true, copyable: false, isEditTopicName: false},
      //   {label: "Target", name: "target", mandatory: true, selected: false, sortable: true, hasSubtitle: false, group: 'Target', cssClass: 'target', align:"right", minWidth: 50, fixed: true, copyable: false, isEditTopicName: false},
      //   // {label: "Total", name: "total", mandatory: true, selected: false, sortable: true, hasSubtitle: false, group: 'Total', cssClass: 'total', align:"right", minWidth: 80, fixed: false, copyable: false, isEditTopicName: false, hasIcon: true},
      //   // {label: "Trend", name: "trendGraph", mandatory: true, selected: false, sortable: true, hasSubtitle: false, group: 'Trend', cssClass: 'trend', align:"centre", minWidth: 150, fixed: false, copyable: false, isEditTopicName: false},
      //   {label: "DynamicFields", name: "dynamicFields", mandatory: false, selected: false, sortable: true, hasSubtitle: false, group: 'DynamicFields', cssClass: 'dynamicFields', minWidth: 225, fixed: false, copyable: false, isEditTopicName: false, hasIcon: true},
      // ],
      corpusColumns: [
        {label: "Corpus", name: "corpus", mandatory: true, selected: false, sortable: true, hasSubtitle: false, group: 'Corpus', cssClass: 'corpus', align:"left", minWidth: 300, fixed: true, copyable: false, isEditTopicName: false},
        {label: "Target", name: "target", mandatory: true, selected: false, sortable: true, hasSubtitle: false, group: 'Target', cssClass: 'target', align:"right", minWidth: 50, fixed: true, copyable: false, isEditTopicName: false},
        // {label: "Total", name: "total", mandatory: true, selected: false, sortable: true, hasSubtitle: false, group: 'Total', cssClass: 'total', align:"right", minWidth: 80, fixed: false, copyable: false, isEditTopicName: false, hasIcon: true},
        // {label: "Trend", name: "trendGraph", mandatory: true, selected: false, sortable: true, hasSubtitle: false, group: 'Trend', cssClass: 'trend', align:"centre", minWidth: 150, fixed: false, copyable: false, isEditTopicName: false},
        {label: "DynamicFields", name: "dynamicFields", mandatory: false, selected: false, sortable: true, hasSubtitle: false, group: 'DynamicFields', cssClass: 'dynamicFields', minWidth: 225, fixed: false, copyable: false, isEditTopicName: false, hasIcon: true},
      ],
      responseColumns: [
        {label: "Response", name: "response", mandatory: true, selected: false, sortable: true, hasSubtitle: false, group: 'Response', cssClass: 'response', align:"left", minWidth: 300, fixed: true, copyable: false, isEditTopicName: false},
        {label: "Target", name: "target", mandatory: true, selected: false, sortable: true, hasSubtitle: false, group: 'Target', cssClass: 'target', align:"right", minWidth: 50, fixed: true, copyable: false, isEditTopicName: false},
        // {label: "Total", name: "total", mandatory: true, selected: false, sortable: true, hasSubtitle: false, group: 'Total', cssClass: 'total', align:"right", minWidth: 80, fixed: false, copyable: false, isEditTopicName: false, hasIcon: true},
        // {label: "Trend", name: "trendGraph", mandatory: true, selected: false, sortable: true, hasSubtitle: false, group: 'Trend', cssClass: 'trend', align:"centre", minWidth: 150, fixed: false, copyable: false, isEditTopicName: false},
        {label: "DynamicFields", name: "dynamicFields", mandatory: false, selected: false, sortable: true, hasSubtitle: false, group: 'DynamicFields', cssClass: 'dynamicFields', minWidth: 225, fixed: false, copyable: false, isEditTopicName: false, hasIcon: true},
      ],
      nluTrainingColumns: [
        {label: "NLU Training", name: "nluTraining", mandatory: true, selected: false, sortable: true, hasSubtitle: false, group: 'NLU Training', cssClass: 'nluTraining', align:"left", minWidth: 300, fixed: true, copyable: false, isEditTopicName: false},
        {label: "Target", name: "target", mandatory: true, selected: false, sortable: true, hasSubtitle: false, group: 'Target', cssClass: 'target', align:"right", minWidth: 50, fixed: true, copyable: false, isEditTopicName: false},
        // {label: "Total", name: "total", mandatory: true, selected: false, sortable: true, hasSubtitle: false, group: 'Total', cssClass: 'total', align:"right", minWidth: 80, fixed: false, copyable: false, isEditTopicName: false, hasIcon: true},
        // {label: "Trend", name: "trendGraph", mandatory: true, selected: false, sortable: true, hasSubtitle: false, group: 'Trend', cssClass: 'trend', align:"centre", minWidth: 150, fixed: false, copyable: false, isEditTopicName: false},
        {label: "DynamicFields", name: "dynamicFields", mandatory: false, selected: false, sortable: true, hasSubtitle: false, group: 'DynamicFields', cssClass: 'dynamicFields', minWidth: 225, fixed: false, copyable: false, isEditTopicName: false, hasIcon: true},
      ],
      conversationsTableColumns: [],
      containedTableColumns: [],
      handedOffTableColumns: [],
      // understandingTableColumns: [],
      //goalsTableColumns: [],
      feedbackTableColumns: [],
      issuesTableColumns: [],
      //customerBehaviourTableColumns: [],
      corpusTableColumns: [],
      responseTableColumns: [],
      nluTrainingTableColumns: [],

      conversationInfo: {
        loading: false,
        noData: false
      },
      containedInfo: {
        loading: false,
        noData: false
      },
      feedbackInfo: {
        loading: false,
        noData: false
      },
      nluTrainingInfo: {
        loading: false,
        noData: false
      },
      handOffInfo: {
        loading: false,
        noData: false
      },
      corpusInfo: {
        loading: false,
        noData: false
      },
      responseInfo: {
        loading: false,
        noData: false
      },
      issuesInfo: {
        loading: false,
        noData: false
      },

      conversationsResults: [],
      containedResults: [],
      messagesResults: [],
      feedbackResults: [],
      responseResults: [],
      corpusResults: [],
      handOffResults: [],
      issuesResults: [],
      nluTrainingResults: [],
      allSummaryResults: [],
      radio: 'date'
    }
  },

  computed: {
    ...mapGetters(['dataModel', 'currentPageInfo', 'companyConfig', 'globalConfig', 'authUser', 'isLoggedIn','companyProfileSettings']),

    showDateFilter() {
      return this.selectedCompareBy == 'date'
    },

    dateRangeTypes() {
      return this.wyChart.getDateRangeTypes();
    }
  },

  watch: {
    'loading': function(val) {
      setTimeout(()=>{
        val ? this.showTable = false : this.showTable = true;
      }, 300)
    }
  },

  methods: {
    ...mapActions(['fetchModelStats', 'trafficManager', 'fetchMetrics', 'fetchOptimizationTableData', 'fetchConversationsData', 'fetchMessagesData', 
    'fetchOptimizationCorpusSummary', 'fetchOptimizationComparisonConversations', 'fetchOptimizationComparisonContained', 'fetchOptimizationComparisonFeedback', 
    'fetchOptimizationComparisonUnderstanding', 'fetchOptimizationComparisonNluTraning', 'fetchOptimizationComparisonCorpus', 'fetchOptimizationComparisonHandedOff', 
    'fetchOptimizationComparisonIssues','fetchOptimizationComparisonResponse']),

    getTableBodyHeight(tableName) {
      let height = this.getTableRecord(tableName) * 62
      return height
    },

    getTableRecord(tableName) {
      let vaoPerformanceComparisonPageMetrics = this.companyConfig ? (((this.companyConfig.appPages || {}).vaoPerformanceComparisonPage || {}).metrics || {}) : {};    
      let tableFieldsMap = WyVaOptimizationUtils.tablesMap[tableName];
      let keys = []
      Object.keys(tableFieldsMap).forEach(key=>{
        if(vaoPerformanceComparisonPageMetrics[key]===undefined || vaoPerformanceComparisonPageMetrics[key] === true) {
          keys.push(key)
        }
      })
      return keys.length
    },

    refreshTable() {
      this.$refs.table.refreshTable();
    },
    handleIndenTableData(tableData, panelName){
      tableData.forEach(el => {
        el.hasIndent = false;
        if(this.containedConversationWithBotIndentList.includes(el[panelName]) && this.globalConfig && this.globalConfig.appPages && this.globalConfig.appPages.vaoPerformanceComparisonPage && this.globalConfig.appPages.vaoPerformanceComparisonPage.metrics && this.globalConfig.appPages.vaoPerformanceComparisonPage.metrics.containedWithBotRequestedFeedback !== false){
          el.hasIndent = true;
        }
        if(this.conversationsHandedOffIndentList.includes(el[panelName]) && this.globalConfig && this.globalConfig.appPages && this.globalConfig.appPages.vaoPerformanceComparisonPage && this.globalConfig.appPages.vaoPerformanceComparisonPage.metrics && this.globalConfig.appPages.vaoPerformanceComparisonPage.metrics.conversationsHandedOffAkaHandoffs !== false){
          el.hasIndent = true;
        }

        if(this.customerMsgsUnderstoodIndentList.includes(el[panelName]) && this.globalConfig && this.globalConfig.appPages && this.globalConfig.appPages.vaoPerformanceComparisonPage && this.globalConfig.appPages.vaoPerformanceComparisonPage.metrics && this.globalConfig.appPages.vaoPerformanceComparisonPage.metrics.nluTrainingMessagesUnderstood !== false){
          el.hasIndent = true;
        }
        
        if(this.customerMsgsNotUnderstoodIndentList.includes(el[panelName]) && this.globalConfig && this.globalConfig.appPages && this.globalConfig.appPages.vaoPerformanceComparisonPage && this.globalConfig.appPages.vaoPerformanceComparisonPage.metrics && this.globalConfig.appPages.vaoPerformanceComparisonPage.metrics.nluTrainingMessagesNotUnderstood !== false){
          el.hasIndent = true;
        }
      })
      return tableData;
    },

    setDefaultHeader(columns) {
      let defaultHeader = []
      if(columns && columns.length > 1) {
        columns.forEach(column => {
          let header = {
            label: column.group
          }
          defaultHeader.push(header)
        })
      }
      return defaultHeader;
    },

    hasSubtitle(columns) {
      let hasSubtitle = false;
      columns.forEach(column => {
        hasSubtitle = column.hasSubtitle;
      });
      return hasSubtitle;
    },

    changeCompareBy() {
      this.$store.dispatch('amplitudeLogWithFilters', {name: 'optimization_performance_comparison_compare_by', data: {compare_by: this.selectedCompareBy}});
      this.handleFilterChange(this.selectedViewDateRange);
    },

    changeDateRange() {
      this.$store.dispatch('amplitudeLogWithFilters', {name: 'optimization_performance_comparison_date_range', data: {date_range: this.selectedViewDateRange}});
      this.handleFilterChange(this.selectedViewDateRange);
    },

    async handleExport() {
      let exportResult = [];
      let exportRow = {};
      let value = "N/A";
      let columnName = '';
      let comparisonTargets = [];
      if(this.companyProfileSettings && this.companyProfileSettings.targetSettings && this.companyProfileSettings.targetSettings.settings && this.companyProfileSettings.targetSettings.settings.optimization){
        comparisonTargets = this.companyProfileSettings.targetSettings.settings.optimization.comparisonTarget;
      }
      let selectedCompareBy = this.selectedCompareBy;

      function handleExportRow(column, row, comparedBy){
        if(comparedBy == 'day' || comparedBy == 'month' || comparedBy == 'quarter'|| comparedBy == 'year'){
          columnName = `${column.group}`.replace(',', '');
        }
        else {
          columnName = `${column.group}`
        }

        const columnValue = row[column.name];
        if (columnName.includes("%")) {
          value = `${Number(columnValue).toLocaleString()}%`
        } else if (typeof columnName == "number") {
          value = Number(columnValue).toLocaleString()
        } else { // string type
          value = columnValue
        }

        if (columnValue == null) {
          if(comparisonTargets.length > 0) {
            if(selectedCompareBy !== 'date'){
              comparisonTargets.forEach(el => {
                if(el.key == row.name){
                  if(el[selectedCompareBy].value == null){
                    exportRow[columnName] = 'N/A';
                  }
                  else {
                    if(el[selectedCompareBy].operator == '='){
                      exportRow[columnName] = 'eq ' + el[selectedCompareBy].value + el[selectedCompareBy].suffix;
                    }
                    else {
                      exportRow[columnName] = el[selectedCompareBy].operator + el[selectedCompareBy].value + el[selectedCompareBy].suffix;
                    }
                  }
                }
              })
              if(exportRow[columnName] == undefined){
                exportRow[columnName] = 'N/A';
              }
            }
            else {
              comparisonTargets.forEach(el => {
                if(el.key == row.name){
                  if(el[comparedBy].value == null){
                    exportRow[columnName] = 'N/A';
                  }
                  else {
                    if(el[comparedBy].operator == '='){
                      exportRow[columnName] = 'eq ' + el[comparedBy].value + el[comparedBy].suffix;                     
                    }
                    else {
                      exportRow[columnName] = el[comparedBy].operator + el[comparedBy].value + el[comparedBy].suffix;
                    }
                  }
                }
              })
              if(exportRow[columnName] == undefined){
                exportRow[columnName] = 'N/A';
              }
            }
          }
          else {
            exportRow[columnName] = 'N/A';
          }
          return exportRow[columnName];
        }
        exportRow[columnName] = value;
        delete exportRow["DynamicFields"]
      }

      if(this.conversationsTableColumns && this.conversationsTableColumns.length > 0){
        this.conversationsResults.forEach(row => {
          this.conversationsTableColumns.forEach(column => {
            handleExportRow(column, row, this.selectedViewDateRange)
          })
          if(Object.keys(exportRow).length !== 1 && exportRow.DynamicFields !== 'N/A')exportResult.push(exportRow);
          exportRow = {};
        })     
      }
      if(this.containedTableColumns && this.containedTableColumns.length > 0){
        this.containedResults.forEach(row => {
          this.containedTableColumns.forEach(column => {
            handleExportRow(column, row, this.selectedViewDateRange)
          })
          if(Object.keys(exportRow).length !== 1 && exportRow.DynamicFields !== 'N/A')exportResult.push(exportRow);
          exportRow = {};
        }) 
      }
      if(this.handedOffTableColumns && this.handedOffTableColumns.length > 0){
        this.handOffResults.forEach(row => {
          this.handedOffTableColumns.forEach(column => {
            handleExportRow(column, row, this.selectedViewDateRange)
          })
          if(Object.keys(exportRow).length !== 1 && exportRow.DynamicFields !== 'N/A')exportResult.push(exportRow);
          exportRow = {};
        }) 
      }
      // if(this.understandingTableColumns && this.understandingTableColumns.length > 0){
      //   this.mappingTableDataByName(understandingTableColumns[0].name).forEach(row => {
      //     this.understandingTableColumns.forEach(column => {
      //       handleExportRow(column, row, this.selectedViewDateRange)
      //     })
      //     if(Object.keys(exportRow).length !== )exportResult.push(exportRow);
      //     exportRow = {};
      //   }) 
      // }
      // if(this.goalsTableColumns  && this.goalsTableColumns.length > 0){
      //   this.mappingTableDataByName(this.goalsTableColumns[0].name).forEach(row => {
      //     this.goalsTableColumns .forEach(column => {
      //       handleExportRow(column, row, this.selectedViewDateRange)
      //     })
      //     if(this.selectedCompareBy == 'date'){
      //       if(Object.keys(exportRow).length !== )exportResult.push(exportRow);
      //       exportRow = {};
      //     }
      //     else{
      //       if(Object.keys(exportRow).length !== 1 && exportRow.DynamicFields !== 'N/A')exportResult.push(exportRow);
      //       exportRow = {};
      //     }
      //   }) 
      // }
      if(this.corpusTableColumns && this.corpusTableColumns.length > 0){
        this.corpusResults.forEach(row => {
          this.corpusTableColumns.forEach(column => {
            handleExportRow(column, row, this.selectedViewDateRange)
          })
          if(Object.keys(exportRow).length !== 1 && exportRow.DynamicFields !== 'N/A')exportResult.push(exportRow);
          exportRow = {};
        }) 
      }
      if(this.responseTableColumns && this.responseTableColumns.length > 0){
        this.responseResults.forEach(row => {
          this.responseTableColumns.forEach(column => {
            handleExportRow(column, row, this.selectedViewDateRange)
          })
          if(Object.keys(exportRow).length !== 1 && exportRow.DynamicFields !== 'N/A')exportResult.push(exportRow);
          exportRow = {};
        }) 
      }
      if(this.feedbackTableColumns  && this.feedbackTableColumns.length > 0 && this.feedbackTableColumns[0]){
        this.feedbackResults.forEach(row => {
          this.feedbackTableColumns.forEach(column => {
            handleExportRow(column, row, this.selectedViewDateRange)
          })
          if(Object.keys(exportRow).length !== 1 && exportRow.DynamicFields !== 'N/A')exportResult.push(exportRow);
          exportRow = {};
        }) 
      }
      if(this.issuesTableColumns && this.issuesTableColumns.length > 0){
        this.issuesResults.forEach(row => {
          this.issuesTableColumns.forEach(column => {
            handleExportRow(column, row, this.selectedViewDateRange)
          })
          if(Object.keys(exportRow).length !== 1 && exportRow.DynamicFields !== 'N/A')exportResult.push(exportRow);
          exportRow = {};
        }) 
      }
      // if(this.customerBehaviourTableColumns  && this.customerBehaviourTableColumns.length > 0){
      //   this.mappingTableDataByName(this.customerBehaviourTableColumns[0].name).forEach(row => {
      //     this.customerBehaviourTableColumns .forEach(column => {
      //       handleExportRow(column, row, this.selectedViewDateRange)
      //     })
      //     if(this.selectedCompareBy == 'date'){
      //       if(Object.keys(exportRow).length !== )exportResult.push(exportRow);
      //       exportRow = {};
      //     }
      //     else{
      //       if(Object.keys(exportRow).length !== 1 && exportRow.DynamicFields !== 'N/A')exportResult.push(exportRow);
      //       exportRow = {};
      //     }
      //   }) 
      // }
      if(this.nluTrainingTableColumns  && this.nluTrainingTableColumns.length > 0){
        this.nluTrainingResults.forEach(row => {
          this.nluTrainingTableColumns.forEach(column => {
            handleExportRow(column, row, this.selectedViewDateRange)
          })
          if(Object.keys(exportRow).length !== 1 && exportRow.DynamicFields !== 'N/A')exportResult.push(exportRow);
          exportRow = {};
        }) 
      }

      function convertToCSV(exportRes) {
        const array = [Object.keys(exportRes[0])].concat(exportRes)
        array[0][0] = 'Metric label';

        // const dynamicColumns = array[0].slice(2);
        // // ignore array[0] (legend), and loop through each and see if values from dynamicColumns exist. If not, put 'N/A'
        // array.forEach((item, index) => {
        //   if (index === 0) return;
        //   dynamicColumns.forEach((column) => {
        //     if (item[column] == null || item[column] == undefined) {
        //       item[column] = 'N/A';
        //     }
        //   });
        // });

        // // ignore array[0], and loop through each object and sort the values by the key, but ignore the first two keys and then re add the first two keys
        // array.forEach((item, index) => {
        //   if (index === 0) return;
        //   const firstTwoKeys = Object.keys(item).slice(0, 2);
        //   const sorted = Object.keys(item).sort().slice(2).reduce((acc, key) => {
        //     acc[key] = item[key];
        //     return acc;
        //   }, {});
          
        //   // put the firsttwo keyts and then the sorted
        //   array[index] = { 
        //     ...firstTwoKeys.reduce((acc, key) => {
        //       acc[key] = item[key];
        //       return acc;
        //     }, {}),  
        //     ...sorted
        //   };
        // });

        const dynamicColumns = array[0].slice(2);
        // loop through each row and see if values from dynamicColumns exist. If not, put '-'
        array.forEach((row, index) => {
          if (index === 0) return;
          dynamicColumns.forEach((column) => {
            if (row[column] == null || row[column] == undefined) {
              row[column] = '-';
            }
          });
        });

        // loop through each row and sort the values by the key, but ignore the first two keys (title, target) and then re-add the first two keys
        array.forEach((row, index) => {
          if (index === 0) return;
          const firstTwoKeys = Object.keys(row).slice(0, 2);
          
          // Use dynamicColumns to sort the keys
          const sorted = dynamicColumns.reduce((acc, key) => {
            if (row.hasOwnProperty(key)) {
              acc[key] = row[key];
            }
            return acc;
          }, {});

          // Add the first two keys and then the sorted keys
          array[index] = {
            ...firstTwoKeys.reduce((acc, key) => {
              acc[key] = row[key];
              return acc;
            }, {}),
            ...sorted
          };
        });

        return array.map(item => {
          return Object.values(item).toString()
        }).join('\n')
      }


      const csv = convertToCSV(exportResult);
      const csvContent = await csv.toString();

      let exportedFilenmae = `${this.authUser.company.name.replace(/ /g, "_")}_Performance_Comparison_${this.dataModel.dateStart}_to_${this.dataModel.dateEnd}.csv`;
      let blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
      let downloadLink = document.createElement("a");
      if (downloadLink.download !== undefined) {
        let url = URL.createObjectURL(blob);
        downloadLink.setAttribute("href", url);
        downloadLink.setAttribute("download", exportedFilenmae);
        downloadLink.style.visibility = 'hidden';
        document.body.appendChild(downloadLink);
        downloadLink.click();
        document.body.removeChild(downloadLink);
      }
    },
    handleTableConditions(){
      if(this.globalConfig && this.globalConfig.appPages && this.globalConfig.appPages.vaoPerformanceComparisonPage && this.globalConfig.appPages.vaoPerformanceComparisonPage.metrics && this.globalConfig.appPages.vaoPerformanceComparisonPage.metrics.conversationsWithBotRequestedFeedback == false && this.globalConfig.appPages.vaoPerformanceComparisonPage.metrics.conversationsThatReceivedPositiveFeedback == false && this.globalConfig.appPages.vaoPerformanceComparisonPage.metrics.conversationsThatReceivedNegativeFeedback == false){
        if(this.companyConfig && this.companyConfig.appPages && this.companyConfig.appPages.vaoPerformanceComparisonPage && this.companyConfig.appPages.vaoPerformanceComparisonPage.metrics && this.companyConfig.appPages.vaoPerformanceComparisonPage.metrics.conversationsWithBotRequestedFeedback == false && this.companyConfig.appPages.vaoPerformanceComparisonPage.metrics.conversationsThatReceivedPositiveFeedback == false && this.companyConfig.appPages.vaoPerformanceComparisonPage.metrics.conversationsThatReceivedNegativeFeedback == false){
          return false;
        }
        return true;
      }
      else if(!(this.companyConfig && this.companyConfig.appPages && this.companyConfig.appPages.vaoPerformanceComparisonPage && this.companyConfig.appPages.vaoPerformanceComparisonPage.metrics && this.companyConfig.appPages.vaoPerformanceComparisonPage.metrics.conversationsWithBotRequestedFeedback == false && this.companyConfig.appPages.vaoPerformanceComparisonPage.metrics.conversationsThatReceivedPositiveFeedback == false && this.companyConfig.appPages.vaoPerformanceComparisonPage.metrics.conversationsThatReceivedNegativeFeedback == false)){
        return true;
      }
      return false;
    },

    mappingTableDataByName(tableName, list) {
      let vaoPerformanceComparisonPageMetrics = this.companyConfig ? (((this.companyConfig.appPages || {}).vaoPerformanceComparisonPage || {}).metrics || {}) : {};      
      let tableFieldsMap = WyVaOptimizationUtils.tablesMap[tableName];
      let tableData = [];
      Object.keys(tableFieldsMap).forEach(key=>{
        list.forEach(item=>{
          if(key == item.name && (vaoPerformanceComparisonPageMetrics[key]===undefined || vaoPerformanceComparisonPageMetrics[key] === true)) {
            item[tableName] = tableFieldsMap[key];
            tableData.push(item)
          }
        });
      })
      return tableData;
    },

    async handleFilterChange(viewBy) {
      if((!this.loading && this.dataModel.dateEnd) || this.dataModel.dateEnd) {
        this.loading = true;
        const dateStart = moment(this.dataModel.dateStart,'YYYY-MM-DD');
        const dateEnd = moment(this.dataModel.dateEnd,'YYYY-MM-DD');
        this.wyChart.init(viewBy, dateStart, dateEnd, this.customDateRangeTypes, (this.companyConfig.default || {}).selectedViewBy);
        this.selectedViewDateRange = this.wyChart.selectedDateRange;        
        
        let options = {
          filters: {
            compareBy: this.selectedCompareBy
          }
        };
        if(this.selectedCompareBy == 'date') {
          options.filters.view = this.customDateRangeTypes[this.selectedViewDateRange].key;
        }         
        
        if(this.pagePanels.conversationsTable) {
          this.conversationsResults = [];
          this.conversationInfo.loading = true
          this.conversationInfo.noData = false;
          this.fetchOptimizationComparisonConversations(options).then((results)=>{
            this.conversationInfo.loading = false
            if(results.length == 0) this.conversationInfo.noData = true;
            this.conversationsResults = this.handleIndenTableData(this.mappingTableDataByName(this.conversationsTableColumns[0].name, results), 'conversations')
            this.prepareTableColumns(this.conversationsTableColumns, this.mappingTableDataByName(this.conversationsTableColumns[0].name, results), this.$refs.conversationsTable);
            this.handleScrollingBar(this.$refs.conversationsTable);
          })
        }
        
        if(this.pagePanels.containedTable) {
          this.containedResults = [];
          this.containedInfo.loading = true
          this.containedInfo.noData = false;
          this.fetchOptimizationComparisonContained(options).then((results)=>{
            this.containedInfo.loading = false;
            if(results.length == 0) this.containedInfo.noData = true;
            this.containedResults = this.handleIndenTableData(this.mappingTableDataByName(this.containedTableColumns[0].name, results), 'contained')
            this.prepareTableColumns(this.containedTableColumns, this.mappingTableDataByName(this.containedTableColumns[0].name, results), this.$refs.containedTable);
            this.handleScrollingBar(this.$refs.containedTable);
          })
        }
        if(this.pagePanels.feedbackTable) {
          this.feedbackResults = [];
          this.feedbackInfo.loading = true;
          this.feedbackInfo.noData = false;
          this.fetchOptimizationComparisonFeedback(options).then((results)=>{
            this.feedbackInfo.loading = false;
            if(results.length == 0) this.feedbackInfo.noData = true;
            this.feedbackResults = this.handleIndenTableData(this.mappingTableDataByName(this.feedbackTableColumns[0].name, results), 'feedback');
            this.prepareTableColumns(this.feedbackTableColumns, this.mappingTableDataByName(this.feedbackTableColumns[0].name, results), this.$refs.feedbackTable);
            this.handleScrollingBar(this.$refs.feedbackTable);
          })
        }
        if(this.pagePanels.nluTrainingTable) {
          this.nluTrainingResults = [];
          this.nluTrainingInfo.loading = true;
          this.nluTrainingInfo.noData = false;
          this.fetchOptimizationComparisonNluTraning(options).then((results)=>{
            this.nluTrainingInfo.loading = false;
            if(results.length == 0) this.nluTrainingInfo.noData = true;
            this.nluTrainingResults = this.handleIndenTableData(this.mappingTableDataByName(this.nluTrainingTableColumns[0].name, results), 'nluTraining');
            this.prepareTableColumns(this.nluTrainingTableColumns, this.mappingTableDataByName(this.nluTrainingTableColumns[0].name, results), this.$refs.nluTrainingTable);
            this.handleScrollingBar(this.$refs.nluTrainingTable);
          })
        }
        if(this.pagePanels.corpusTable) {
          this.corpusResults = [];
          this.corpusInfo.loading = true;
          this.corpusInfo.noData = false;
          this.fetchOptimizationComparisonCorpus(options).then((results)=>{
              this.corpusInfo.loading = false;
              if(results.length == 0) this.corpusInfo.noData = true;
              this.corpusResults = this.handleIndenTableData(this.mappingTableDataByName(this.corpusTableColumns[0].name, results), 'corpus');
              this.prepareTableColumns(this.corpusTableColumns, this.mappingTableDataByName(this.corpusTableColumns[0].name, results), this.$refs.corpusTable);
              this.handleScrollingBar(this.$refs.corpusTable);
          })
        }
        if(this.pagePanels.handedOffTable) {
          this.handOffResults = [];
          this.handOffInfo.loading = true
          this.handOffInfo.noData = false;
          this.fetchOptimizationComparisonHandedOff(options).then((results)=>{
            this.handOffInfo.loading = false;
            if(results.length == 0) this.handOffInfo.noData = true;
            this.handOffResults = this.handleIndenTableData(this.mappingTableDataByName(this.handedOffTableColumns[0].name, results), 'handedOff');
            this.prepareTableColumns(this.handedOffTableColumns, this.mappingTableDataByName(this.handedOffTableColumns[0].name, results), this.$refs.handedOffTable);
            this.handleScrollingBar(this.$refs.handedOffTable);
          })
        }
        if(this.pagePanels.responseTable) {
          this.responseResults = [];
          this.responseInfo.loading = true
          this.responseInfo.noData = false;
          this.fetchOptimizationComparisonResponse(options).then((results)=>{
            this.responseInfo.loading = false;
            if(results.length == 0) this.responseInfo.noData = true;
            this.responseResults = this.handleIndenTableData(this.mappingTableDataByName(this.responseTableColumns[0].name, results), 'response');
            this.prepareTableColumns(this.responseTableColumns, this.mappingTableDataByName(this.responseTableColumns[0].name, results), this.$refs.responseTable);
            this.handleScrollingBar(this.$refs.responseTable);
          })
        }
        if(this.pagePanels.issuesTable) {
          this.issuesResults = [];
          this.issuesInfo.loading = true
          this.issuesInfo.noData = false;
          this.fetchOptimizationComparisonIssues(options).then((results)=>{
            this.issuesInfo.loading = false;
            if(results.length == 0) this.issuesInfo.noData = true;
            this.issuesResults = this.handleIndenTableData(this.mappingTableDataByName(this.issuesTableColumns[0].name, results), 'issues');
            this.prepareTableColumns(this.issuesTableColumns, this.mappingTableDataByName(this.issuesTableColumns[0].name, results), this.$refs.issuesTable);
            this.handleScrollingBar(this.$refs.issuesTable);
          })
        }

        this.conversationsTableColumns = JSON.parse(JSON.stringify(this.conversationsColumns));
        this.containedTableColumns = JSON.parse(JSON.stringify(this.containedColumns));
        this.handedOffTableColumns = JSON.parse(JSON.stringify(this.handedOffColumns));
         //Hide by OC-556 base on OC-418
        // this.understandingTableColumns = JSON.parse(JSON.stringify(this.understandingColumns));
        // this.goalsTableColumns = JSON.parse(JSON.stringify(this.goalsColumns));
        this.feedbackTableColumns = JSON.parse(JSON.stringify(this.feedbackColumns));
        this.issuesTableColumns = JSON.parse(JSON.stringify(this.issuesColumns));
        // this.customerBehaviourTableColumns = JSON.parse(JSON.stringify(this.customerBehaviourColumns));
        this.corpusTableColumns = JSON.parse(JSON.stringify(this.corpusColumns));
        this.responseTableColumns = JSON.parse(JSON.stringify(this.responseColumns));
        this.nluTrainingTableColumns = JSON.parse(JSON.stringify(this.nluTrainingColumns));
      }
    },

    handleScrollingBar(refTable) {
      if(refTable && refTable.$el) {
        let dom = refTable.$el
        setTimeout(()=> {
          if(dom.querySelector("tbody") && dom.querySelector("tbody tr")) {
            if(dom.querySelector("tbody tr").getBoundingClientRect().width > dom.getBoundingClientRect().width) {
              dom.querySelector("tbody").style["overflow-x"] = "scroll"
            }
            else {
              dom.querySelector("tbody").style["overflow-x"] = "auto"
            }
          }
        }, 200)
      }
    },

    mergeAllSummaryResult(originList, list) {
      originList.forEach((item, index)=>{
        list.forEach(mergeItem=>{
          if(item.name == mergeItem.name) {
            this.allSummaryResults[index] = mergeItem
          }
        })
      })
    },

    prepareTableColumns(columns, tableDataResults, refsTable) {
      if(tableDataResults.length > 0) {
        let dynamicFields = columns.find(el => el.name == 'dynamicFields')
          if(tableDataResults[0].dynamicFields && tableDataResults[0].dynamicFields.length > 0) {
          let map = WyUtils.languageMap;

          tableDataResults[0].dynamicFields.forEach(field => {
            let obj = JSON.parse(JSON.stringify(dynamicFields))
            obj.label = map[Object.keys(field)[0]] ? map[Object.keys(field)[0]] : Object.keys(field)[0];
            if(this.selectedCompareBy == 'date' && obj.label.split(' - ').length > 1) {
              let fromDate = moment(obj.label.split(' - ')[0]).format("MMM Do, YYYY");
              let toDate = moment(obj.label.split(' - ')[1]).format("MMM Do, YYYY");
              if(obj.label.split(' - ')[0] == obj.label.split(' - ')[1]) {  // same date will show 1 date
                obj.label = fromDate;
              }
              else {
                if(fromDate.substr(fromDate.length - 4) == toDate.substr(toDate.length - 4)) {
                  obj.label = fromDate.substr(0, fromDate.length - 6) + " - " + moment(obj.label.split(' - ')[1]).format("MMM Do, YYYY")
                }
                else {
                  obj.label = moment(obj.label.split(' - ')[0]).format("MMM Do, YYYY") + " - " + moment(obj.label.split(' - ')[1]).format("MMM Do, YYYY")
                }
              }
            }
            let channels = this.dataModel.filters.custTypes.dataSource;
            channels.forEach((channel)=>{
              if(channel.key == obj.label) {
                obj.label = channel.label;
              }
            })
            obj.name = Object.keys(field)[0];
            obj.group = obj.label;
            columns.push(obj)
          })
        }
        else {
          //TODO handle if there is an empty array
        }
      }
      
      // setTimeout(()=>{
        if(refsTable) refsTable.refreshTable();
      // }, 500)
    }

  },

  async created() {        
    this.wyChart = new WyChartModule();
    this.initDate = new Date();
    this.pagePanels = this.companyConfig ? (((this.companyConfig.appPages || {}).vaoPerformanceComparisonPage || {}).panels || {}) : {};
    await this.handleFilterChange();

    // listen events from other components
    this.$root.registerPageEvent(this.$route.name, (event) => {
      if(this[event.name]) this[event.name]();
    }) 
  },

  destroyed() {
    if(this.isLoggedIn) {
      this.$store.dispatch('amplitudeLogWithFilters', {name: 'optimization_performance_comparison_time_spent', data: {time_spent: WyUtils.getTimeDiff(this.initDate)}});
    }
  }
});
</script>

<style lang="scss">
  .wy-va-optimization-comparison {
    font-weight: 500;
    font-size: 14px;
    // padding-top: 18px;
    .comparison-small-title {
      display: none;
      color: var(--site-font-secondary-color);
      font-size: 15px;
      font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
      font-weight: 400;
    }
    .el-loading-mask {
      height: calc(100vh - 100px) !important;
    }
    .wy-genaric-table .wy-table-main thead th {
      min-width: 233px !important;
    }
    .wy-genaric-table .wy-table-main tr td {
      min-width: 233px !important;
    }

    .performace-comparison-title {
      display: flex;
      justify-content: space-between;
      color: var(--site-font-secondary-color);
      font-size: 25px;
      font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
      font-weight: 600;
      margin-bottom: 37px;
      line-height: 0.7;
      height: 25px;
      .export-btn {
        box-sizing: border-box;
        border-radius: 5px;
        background: var(--site-button-secondary-btn-background-primary-color);
        color: var(--site-button-secondary-btn-text-primary-color) !important;
        border: 1px solid var(--site-button-secondary-btn-hover-border-primary-color);
        padding: 6px 15px 9px 11px !important;
        width: 90px;
        font-size: 16px !important;
        font-weight: 500 !important;
        height: 39px;
        float: right;
        &:hover{
          background-color: #F4F6F8;
        }
      }
      .export-btn:hover {
        border: 1px var(--site-button-secondary-btn-hover-border-primary-color) solid !important;
        background-color: var(--site-button-secondary-btn-hover-background-primary-color) !important;
        border-radius: 5px;
        color: var(--site-button-secondary-btn-text-primary-color) !important;
      }
      .export-btn:active {
        background-color: var(--site-button-secondary-btn-pressed-background-primary-color) !important;
      }
      .export-btn:focus {
        border: 1px var(--site-button-secondary-btn-hover-border-primary-color) solid !important;
        border-radius: 5px;
        color: var(--site-button-secondary-btn-text-primary-color) !important;
      }
      .export-icon {
        background: var(--icon_action_export);
        height: 17px;
        width: 13px;
        position: relative;
        top: 2px;
        height: 17px;
        width: 13px;
        display: inline-block;
        background-repeat: no-repeat;
      }
      .export-text {
        position: relative;
        bottom: 1px;
        left: 5px;
      }
    }

    .wy-optimization-table-section {
      margin-bottom: 20px;
      .wy-optimization-table-section-header {
        display: flex;
        padding: 0px 5px 6px 0px;
        // background-color: #F4F6F8;
        background-color: #FFF;
        border-radius: 4px;
        min-width: 200px;
        margin-left: auto;

        .compare-by-label {
          padding: 0px 35px 0px 0px;
          font-size: 14px;
        }
        .el-radio {
          margin-right: 10px;
        }
        .el-radio.radio-language {
          margin-right: 40px;
        }

        .compare-by-title {
          padding-top: 6px;
          margin-left: 30px;
          margin-right: 2px;
          font-size: 10px;
        }
        .view-date-range-title {
          padding-top: 6px;
          margin-right: 2px;
          font-size: 10px;
        }
        .compare-by-dropdown .el-input__inner {
          width: 80px;
          padding-left: 10px;
          padding-right: 20px;
        }
        .date-range-dropdown {
          margin-right: 40px;
          .el-input__inner {
            width: 100px;
            padding-left: 10px;
            padding-right: 20px;
          }
        }
        input.el-input__inner {
            border-width: 0px 0px 0px 0px !important;
        }
        .el-select .el-input.is-focus .el-input__inner {
          border-color: transparent;
        }
        .el-radio__input.is-checked .el-radio__inner {
          border-color: #214586;
          background: #214586;
        }
        .el-radio__input.is-checked+.el-radio__label {
          color: var(--site-font-primary-color);
        }
        .el-radio__inner:hover {
          border-color: #214586;
        }
        .el-input--mini {
          font-size: 14px;
        }
        .el-select>.el-input {
          border: #c0c4cc solid 1px;
          border-radius: 4px;
          padding: 4px;
        }
        .el-input--mini .el-input__inner {
          height: 20px;
          line-height: 20px;
          // background-color: #F4F6F8;
        }
        .el-select .el-input__inner:focus {
          border-color: transparent;
        }
        .el-input--mini .el-input__icon {
          line-height: 23px;
        }
        .el-select.el-select--mini {
          box-sizing: border-box;
          border-radius: 3px;
          width: 150px;
          padding: 0px;
          margin-left: 0px;
        }
        .el-select__caret {
          background-image: url('../../assets/icons/icon_dropdown_arrow_down.svg');
          background-repeat: no-repeat;
          background-size: 8px 5px;
          background-position-x: 3px;
          background-position-y: 12px;
          width: 11px;
          height: 18px;
          vertical-align: middle;
          transform: rotate(0);
        }
        .el-icon-arrow-up:before {
          content: "";
        }
      }
      .el-input.is-disabled .el-input__inner {
        background-color: #FFF;
      }
    }

    .optimization-details {
      padding-left: 25px;
      padding-right: 25px;
      padding-bottom: 20px;

      .optimization-details-table {
        width: 100%;
        td {
          text-align: center;
          width: 25%;
        }
      }
    }

    .wy-genaric-table {
      // width: calc(100% - 17px);  
      width: calc(100% - 0px);
      margin-top: 10px;
      margin-bottom: 20px;
      // padding: 0 10px 0 6px;
      // padding: 0 1px 0 1px;
      padding: 0px;
      border-radius: 5px;
      // box-shadow: 3px 3px 12px #9d9cc759;
      // box-shadow:  0px 1px 0px #d0d0d059;
      border: 1px solid #CAD2DA;

      .el-no-data {
        cursor: pointer;
        background-image: url('../../assets/icons/icon_comparison_data_not_available.svg') !important;
        background-size: 16px !important;
        background-repeat: no-repeat;
        background-position-y: 1px !important;
        background-position-x: 12px !important;
        background-color: transparent !important;
        height: 16px !important;
        width: 29px;
        border: 0px;
      }
      table.wy-table-main {
        border-spacing: 0px;
        tbody {
          border-bottom: 0px solid #eee;
          tr {
            width: calc( 100vw - 355px);
          }
          .highlightedRow {
            background-color: #f5f7fa !important;
          }
        }

        .ct-series-a .ct-bar, .ct-series-a .ct-line, .ct-series-a .ct-point, .ct-series-a .ct-slice-donut {
            stroke: #214586;
        }
        .ct-line {
            stroke-width: 1px;
        }
      }
      table.wy-table-main thead {
        border-bottom: 1px solid #ddd;
        width: 100%;
      }
      table.wy-table-main tbody {   
        // max-height: 300px;  
        height: 100%;
        // width: 100%;
        width: calc( 100vw - 355px);
        tr {
          // width: max-content;
          width:100%;
        }
        &::-webkit-scrollbar {
          width: 20px;
          height: 20px;
        }
        &::-webkit-scrollbar-thumb {
          border-radius: 150px;
          border: 5px solid transparent;
          border-top: 6px solid transparent;
          background-clip: content-box;
          background-color: #CAD2DA;
        }
        &::-webkit-scrollbar-track {
          background:#FFF;
          border-top: 1px solid #CAD2DA;
        }
        &::-webkit-scrollbar:vertical {
          width: 14px;
        }
        &::-webkit-scrollbar-thumb:vertical {
          border-radius: 160px;
          border: 2px solid transparent;
          border-left: 4px solid transparent;
          background-clip: content-box;
          background-color: #CAD2DA;
        }
        &::-webkit-scrollbar-track:vertical {
          border-top: none !important;
          border-left: 1px solid #CAD2DA;
        }
      }
      table.wy-table-main {
        border-radius: 6px;
      }
      
      .wy-table-wrapper {
        width: auto !important;
        padding: 6px 0px 0px 0px;
        // margin-bottom: 18px;
        background: #FFFFFF;
        border-radius: 6px;
        overflow-y: hidden;

        thead tr th {
          color: #0C2837;
          background-color: #FFF;
        }
        thead tr th:first-child {
          text-align: left !important;
        }

      }
      .wy-table-fixed {
        top: 0px;
        // padding: 0px 6px;
        // padding: 0px 1px;
        padding: 0px;
        border-radius: 6px;
        width: 553px !important;
        margin-top: 6px;
        margin-bottom: 6px;
        border-left: 1px solid #FFF;
      }
      .wy-table-fixed.show-fixed-table-shadow {
        // -webkit-box-shadow: 3px 3px 12px #9d9cc759;
        // box-shadow: 3px 3px 12px #9d9cc759;
        background-color: white;
        // border-left: 1px solid #eeeeeead;
        // padding: 0px 0px 0px 6px;
        padding: 0px 0px 0px 0px;
      }

      thead {
        border-bottom: 1px solid #ddd;
        .wy-header {
          font-size: 14px;
          font-weight: 600;
        }
        span.dynamicFields {
          width: fit-content;
          // float: right;
          padding-right: 2px;
        }
      }
      .wy-table-fixed tbody tr td:first-child {
        background-color: #FFF;
      }
      .no-data-body .el-loading-mask {
        height: unset !important;
      }
      tbody {
        font-size: 14px;

        td.last-child.align-right div{
          margin-left: unset !important;
          padding-right: 2px !important;
          display: flex !important;
          justify-content: center !important;
        }

        td.last-child.align-right span {
          display: flex !important;
          justify-content: center !important;
          // padding-right: 62px;
        }
        tr td {
          border-bottom: 0px !important;
        }
        td div.dynamicFields {
          width: fit-content;
          float: right;
          width: 100%;
          padding-right: 1px !important;
        }

        tr td.last-child .icon-red-warning {
          background-position-y: 3px;
          background-position-x: 1px;
          padding-right: 0px;
        }
        tr td.last-child .icon-green-check {
          padding-right: 1px;
        }
      }

      .wy-table-fixed {
        thead {
          th:nth-last-child(1) {
            padding-left: 15px;
            min-width: 185px !important;
          }
        }
        tbody {
          height: unset !important;
          td:nth-last-child(1) { 
            padding-left: 15px;
            min-width: 185px !important;
            max-width: 185px !important;
          }
        }
      }
      .wy-table-tail {
        min-width: 16px;
        display: none;
      }
    }

    .no-result-found .no-data {
      height: 100px;
      background-size: 100px;
    }
  }
  .table-filter-dropdown.compare-by {
    left: -70px !important;
  }
  .table-filter-dropdown.date-range {
    width: 160px;
    left: 0px !important;
  }
  
  .wy-va-optimization-comparison .table-filter-dropdown {
    width: 158px;
    top:  16px !important;

    .el-select-dropdown__item {
      height: 23px;
      line-height: 23px;
      font-size: 14px;
      font-weight: normal;
      padding: 0 10px 0 5px;
      margin: 2px 10px 0px 10px;

      span {
        line-height: 23px;
      }
    }

    .el-select-dropdown__item.selected {
      border: 0.5px solid #214586;
      box-sizing: border-box;
      border-radius: 3px;
      background-image: url('../../assets/icons/icon-blue-check.svg') !important;
      background-repeat: no-repeat;
      background-position-y: 6px;
      background-position-x: 120px;
    }
    .el-select-dropdown__item:hover {
      background-color: #E5EAF2 !important;
      border-radius: 3px;
      background-repeat: no-repeat;
      background-position-y: 6px;
      background-position-x: 120px;
    }

    .el-select-dropdown__item.hover {
      background-color: unset;
      border-radius: 3px;
      background-repeat: no-repeat;
      background-position-y: 6px;
      background-position-x: 120px;
    }
  }


</style>